<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="order-tab" data-bs-toggle="tab" data-bs-target="#order-tab-pane" type="button" role="tab" aria-controls="order-tab-pane" aria-selected="true">بيانات الطلب</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="providers-tab" data-bs-toggle="tab" data-bs-target="#providers-tab-pane" type="button" role="tab" aria-controls="providers-tab-pane" aria-selected="false">المزودين المقترحين</button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade p-3 show active" id="order-tab-pane" role="tabpanel" aria-labelledby="order-tab" tabindex="0">
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع الطلب:</label>
                  <div class="d-inline-block ms-2">{{ orderTypes[dataRow.orderType] }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الخدمة:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.MaintenanceIssue)? dataRow.MaintenanceIssue.name : 'غير معروف' }}</div>
                </div>
              </div>

              <!-- Requester Type & Coupon Info -->
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نوع مقدم الطلب:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.orderType === 'global'" class="badge bg-info">عميل عادي</span>
                    <span v-else-if="dataRow.orderType === 'mosque'" class="badge bg-secondary">جهة عامة</span>
                    <span v-else-if="dataRow.mobile || dataRow.name" class="badge bg-primary">
                      {{ dataRow.name || 'مستأجر / مالك' }}
                    </span>
                    <span v-else-if="dataRow.User && dataRow.User.id" class="badge bg-success">عميل مسجل</span>
                    <span v-else class="badge bg-secondary">غير معروف</span>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">كوبون الخصم:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.couponId && dataRow.couponAccepted" class="badge bg-success">
                      <i class="fa-solid fa-tag me-1"></i>
                      مُطبَّق — 
                      <span v-if="dataRow.couponType === 'percentage'">{{ dataRow.couponAmount }}٪ خصم</span>
                      <span v-else>{{ dataRow.couponAmount }} ريال خصم</span>
                    </span>
                    <span v-else-if="dataRow.couponId && !dataRow.couponAccepted" class="badge bg-warning text-dark">
                      <i class="fa-solid fa-tag me-1"></i>كوبون (لم يُقبل)
                    </span>
                    <span v-else class="badge bg-light text-muted">لا يوجد كوبون</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">اسم العميل:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">جوال العميل:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.User)? dataRow.User.mobile : 'غير معروف' }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label class="form-label" for="">المزود:</label>
                  <div class="d-inline-block ms-2">{{ providerMobile }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <loader v-if="providerLoader" />
                  <div v-if="providerName">
                    <label class="form-label" for="">اسم المزود:</label>
                    <div>{{ providerName }}</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">المشكلة:</label>
                  <div>{{ dataRow.title }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">المشكلة (مترجمة):</label>
                  <div>{{ dataRow.titleEn }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف المشكلة:</label>
                  <div>{{ dataRow.description }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وصف المشكلة (مترجمة):</label>
                  <div>{{ dataRow.descriptionEn }}</div>
                </div>
              </div>

              <div class="row">
                <div v-if="dataRow.image" class="col-12 col-sm-6 text-center mb-3">
                  <video v-if="isIssueVideo" :src="MEDIA_URL+dataRow.image" class="img-thumbnail img-fluid w-100" style="max-height: 350px;" controls preload="metadata" playsinline aria-label="فيديو المشكلة">متصفحك لا يدعم تشغيل الفيديو.</video>
                  <img v-else :src="MEDIA_URL+dataRow.image" class="img-thumbnail img-fluid" alt="صورة المشكلة">
                  <a v-if="isIssueVideo" :href="MEDIA_URL+dataRow.image" class="d-block mt-2" target="_blank" rel="noopener noreferrer">فتح الفيديو</a>
                </div>
                <div class="col-12 col-sm-6">
                  <div ref="orderMap" style="width: 100%; height: 350px;"></div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">المنطقة:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">المدينة:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الحي:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.Neighborhood">{{ dataRow.Neighborhood.name }}</span>
                    <span v-else-if="dataRow.neighborhoodId" class="text-muted">#{{ dataRow.neighborhoodId }}</span>
                    <span v-else class="text-muted">غير معروف</span>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">مصدر الطلب:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">لوحة التحكم</span>
                    <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">Iphone</span>
                    <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
                    <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">الموقع الإلكتروني</span>
                    <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
                    <span v-else class="text-muted">غير محدد</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وقت تعيين المزود:</label>
                  <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.assignTime) }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وقت وصول المزود:</label>
                  <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.arriveTime) }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وقت إتمام الطلب:</label>
                  <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.doneTime) }}</div>
                  <div v-if="dataRow.doneNotice" class="d-inline-block ms-2">{{ dataRow.doneNotice }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">وقت إلغاء الطلب:</label>
                  <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.cancelTime) }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">مبلغ جدية الطلب:</label>
                  <div class="d-inline-block ms-2">{{ dataRow.deposit }} ريال</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الإكرامية:</label>
                  <div class="d-inline-block ms-2">{{ tip }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">سعر شغل اليد:</label>
                  <div class="d-inline-block ms-2">{{ price }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">سعر قطع الغيار:</label>
                  <div class="d-inline-block ms-2">{{ partsPrice }}</div>
                </div>
              </div>
              <div
                v-if="dataRow.partsInvoice && dataRow.partsInvoice.length"
                class="row"
                >
                <div class="col-12 mb-3">
                  <label class="form-label">
                    فواتير قطع الغيار:
                  </label>
                  <div class="row mt-2">
                    <div
                      v-for="(invoice, index) in dataRow.partsInvoice"
                      :key="index"
                      class="col-12 col-md-6 col-lg-4 mb-3"
                    >
                      <div class="card p-2 h-100">
                        <img
                          v-if="isImage(invoice)"
                          :src="MEDIA_URL + invoice"
                          class="img-fluid rounded border"
                          style="max-height:250px; object-fit:contain;"
                        />
                        <iframe
                          v-else
                          :src="MEDIA_URL + invoice"
                          width="100%"
                          height="250"
                          style="border:1px solid #ddd; border-radius:8px;"
                        ></iframe>
                        <div class="mt-2 text-center">
                          <a
                            :href="MEDIA_URL + invoice"
                            target="_blank"
                            class="btn btn-outline-primary btn-sm"
                          >
                            <i class="fa-solid fa-eye me-1"></i>
                              عرض الملف
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">قيمة عمولة المحيسني العقارية:</label>
                  <div class="d-inline-block ms-2">{{ dataRow.commissionAmount }} ريال</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">نسبة عمولة المحيسني العقارية:</label>
                  <div class="d-inline-block ms-2">{{ dataRow.commissionPercentage }}٪</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">طريقة الدفع:</label>
                  <div class="d-inline-block ms-2">{{ paymentGateList[paymentGate] }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">حالة الطلب:</label>
                  <div class="d-inline-block ms-2">{{ orderStatus[status] }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <div class="form-check">
                    <label class="form-check-label">
                      <i v-if="isPaid" class="fa-regular fa-circle-check"></i>
                      <i v-else class="fa-regular fa-circle-xmark"></i>
                      تم سداد قيمة الطلب بنجاح
                    </label>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">سبب الإلغاء - <small>في حالة كان الطلب لاغي</small> :</label>
                  <div class="d-inline-block ms-2">{{ orderCancelAdmin[cancelReason] }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تاريخ الطلب:</label>
                  <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
                </div>
                <div v-if="dataRow.paymentId" class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">بيانات السداد:</label>
                  <div>
                    <router-link :to="`/payments/update/${dataRow.paymentId}`">عرض بيانات السداد</router-link>
                  </div>
                </div>
              </div>

              <div v-if="dataRow.holdTime" class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تاريخ الإقاف المؤقت:</label>
                  <div class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.holdTime) }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">سبب التوقف المؤقت:</label>
                  <div class="d-inline-block ms-2">{{ (dataRow.holdReason)? orderHoldReasons[dataRow.holdReason] : 'غير معروف' }}</div>
                  <div class="d-inline-block ms-2">{{ dataRow.holdDetails }}</div>
                </div>
              </div>

              <div v-if="dataRow.imageAfter || dataRow.imageBefore" class="row">
                <div v-if="dataRow.imageBefore" class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الصورة قبل الإصلاح:</label>
                  <img :src="MEDIA_URL+dataRow.imageBefore" class="img-thumbnail img-fluid" alt="">
                </div>
                <div v-if="dataRow.imageAfter" class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الصورة بعد الإصلاح:</label>
                  <img :src="MEDIA_URL+dataRow.imageAfter" class="img-thumbnail img-fluid" alt="">
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">تقييم العميل:</label>
                  <div class="d-inline-block ms-2">{{ dataRow.rate }}</div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">ملاحظات العميل:</label>
                  <div class="d-inline-block ms-2">{{ dataRow.rateNote }}</div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade p-3" id="providers-tab-pane" role="tabpanel" aria-labelledby="providers-tab" tabindex="0">
              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>الاسم</th>
                          <th>الجوال</th>
                          <th>الحالة</th>
                          <th>سبب الرفض</th>
                          <th>وقت الارسال</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="acceptance in dataRow.ProvidersOrdersAcceptances" :key="acceptance.id">
                          <td>{{ acceptance.id }}</td>
                          <td>{{ (acceptance.Provider)? acceptance.Provider.name : 'غير معروف' }}</td>
                          <td>{{ (acceptance.Provider)? acceptance.Provider.mobile : 'غير معروف' }}</td>
                          <td>{{ providerAcceptanceStatus[acceptance.status] }}</td>
                          <td>{{ (acceptance.rejectReason)? orderRejectReasons[acceptance.rejectReason] : '' }}</td>
                          <td class="date-format">{{ formatDate(acceptance.createdAt) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, formatDate, isImage } from '@/helpers/tools';

export default {
  name: 'OrdersView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    orderStatus: {
      type: Object,
      default: null,
    },
    orderCancelAdmin: {
      type: Object,
      default: null,
    },
    orderTypes: {
      type: Object,
      default: null,
    },
    orderRejectReasons: {
      type: Object,
      default: null,
    },
    orderHoldReasons: {
      type: Object,
      default: null,
    },
    providerAcceptanceStatus: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      providerLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      map: null,
      marker: null,
      providerMobile: null,
      providerName: null,
      providerId: null,
      price: 0,
      partsPrice: 0,
      tip: 0,
      status: null,
      cancelReason: null,
      paymentGate: null,
      isPaid: false,
      paymentGateList: {
        online: 'دفع إلكتروني',
        wallet: 'محفظة',
        applepay: 'ابل باي',
        cash: 'كاش',
      },
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    isIssueVideo() {
      const image = this.dataRow && this.dataRow.image;
      return !!image && (this.dataRow.imageFileType === 'video' || /\.(mp4|mov)(?:[?#]|$)/i.test(image));
    }
  },
  methods: {
    formatDate,
    // google map 
    initMap(){
      if (!this.$refs.orderMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.orderMap, {
        center: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    isImage,
  },
  created(){
    if(this.dataRow){
      this.providerId = this.dataRow.providerId;
      this.price = this.dataRow.price;
      this.partsPrice = this.dataRow.partsPrice;
      this.tip = this.dataRow.tip;
      this.status = this.dataRow.status;
      this.cancelReason = this.dataRow.cancelReason;
      this.paymentGate = this.dataRow.paymentGate;
      this.isPaid = this.dataRow.isPaid;
      if(this.dataRow.Provider){
        this.providerMobile = this.dataRow.Provider.mobile;
        this.providerName = this.dataRow.Provider.name;
      }
      this.initialGoogleMap();
    }
  }
}
</script>